module.exports = __webpack_public_path__ + "img/banner1.5427ce11.jpg";